module.exports = "<div class=\"leaflet-control obs-presentation-button\" title=\"Afficher la présentation de l'observatoire\" ng-click=openPresentationPopin()> <i class=\"fa fa-info\"></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/presentation/obsPresentationButton.html
// module id = 3577
// module chunks = 12